@import '@teelmo/web-styles';

html, body {
  margin: 0;
  padding: 0;

  .legend {
    left: 10px;
    position: fixed;
    top: 0;

    > div {
      display: inline-block;
      margin: 0 20px 5px 0;

      .indicator {
        vertical-align: middle;
      }

      .label {
        font-family: sans-serif;
        line-height: 20px;
        vertical-align: middle;
      }
    }
  }
}
